import React, { useState, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

function UpdateMealType() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
  });
  const [selectedMealType, setSelectedMealType] = useState(null);

  // Get meal type data from localStorage (set when edit button is clicked)
  useEffect(() => {
    const mealTypeData = localStorage.getItem("selectedMealType");
    if (mealTypeData) {
      const parsedData = JSON.parse(mealTypeData);
      setSelectedMealType(parsedData);
      setFormData({
        title: parsedData.title || "",
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      toast.error("Please enter meal type title");
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.title.trim())) {
      toast.error("Meal type title should only contain letters and spaces");
      return;
    }

    setLoading(true);
    try {
      const response = await handleApiCall("patch", `${endpoints.updateMealType}/${id}`, {
        title: formData.title,
      });

      if (response?.data?.code === 200) {
        toast.success(response?.data?.message || "Meal type updated successfully!");
        // Clean up localStorage
        localStorage.removeItem("selectedMealType");
        // Add a small delay to ensure toast is shown before navigation
        setTimeout(() => {
          navigate("/meal-type");
        }, 1000);
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error updating meal type:", error);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      title: "",
    });
    // Clean up localStorage
    localStorage.removeItem("selectedMealType");
    navigate("/meal-type");
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Update Meal Type</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? "Updating..." : "Update"}
                    </Button>
                    <Button type="button" className="rounded-lg ml-4 bg-white" onClick={handleCancel} disabled={loading}>
                      Cancel
                    </Button>
                  </div>
                </div>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Title" name="title" value={formData.title} onChange={handleInputChange} required />
                  </div>
                  {/* Commented out start time and end time fields as per requirement */}
                  {/* <div className="form-group col-md-4 px-2">
                    <input type="date" className="form-control default" placeholder="Start Time"/>
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="date" className="form-control default" placeholder="End Time"/>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateMealType;
